import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class ThematicInspectorXhrConfiguration {
    @JsonProperty()
    declare usePost: boolean;
    @JsonProperty()
    declare useProxy?: boolean;
    @JsonProperty()
    declare timeout?: number;
    @JsonProperty()
    declare responseType?: "json" | "xml" | "text" | "blob" | "array-buffer" | "document" | "image";
}
@JsonObject()
export class ThematicInspectorConfiguration {
    @JsonProperty()
    declare url: string;

    @JsonProperty()
    declare xhrOptions: ThematicInspectorXhrConfiguration;

    @JsonProperty()
    declare hideProjekte: string[];

    @JsonProperty()
    declare errorMessage: string;

    @JsonProperty()
    declare notFoundMessage: string;

    constructor() {}
}
